exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#option-box[data-v-9c35dec2] {\n  text-align: center;\n  max-width: 510px;\n  margin: 10px auto;\n  border: solid 1px black;\n}\n.option-content[data-v-9c35dec2] {\n  text-align: left;\n}\n.text-area[data-v-9c35dec2] {\n  text-align: left;\n  margin: 10px auto;\n  max-width: 500px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-9c35dec2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ReschedulingPage/ReschedulingOptionForm.vue
// module id = 540
// module chunks = 0